import {
  ClientCategoryIndicatorsOverview,
  IndicatorItemData,
} from "../models/data-structures";
import { ReactElement, useState } from "react";
import { WarningOutlined } from "@ant-design/icons";
import iconMapper from "../util/Category-icon-mapper";
import InnerCard from "../shared-ui-components/InnerCard";
import "./IndicatorOverviewsInnerCard.scss";
import {
  categoryDescriptions,
  categoryTitles,
  getVerdictByRating,
} from "../logic/business-rules";
import { toKebabCase } from "../util/general";
import Link from "antd/lib/typography/Link";
import ToolTip from "../shared-ui-components/ToolTip";

export interface IndicatorOverviewsInnerCardProps extends ClientCategoryIndicatorsOverview {
  className?: string;
}

const IndicatorCardItem = (props: IndicatorItemData) => {
  return (
    <>
      <div className="flex-row-with-vertical-alignment">
        <span className="finding-text">&#8226; {props.description}</span>
        {props.rating > 0 && (
          <div
            className={
              "finding-rating " + toKebabCase(getVerdictByRating(props.rating))
            }
          >
            {props.rating.toFixed(0)}
          </div>
        )}
      </div>
      {!!props.extraInfo && (
        <div className="finding-extra-info">{props.extraInfo}</div>
      )}
    </>
  );
};

export function IndicatorOverviewsInnerCard(
  props: IndicatorOverviewsInnerCardProps,
): ReactElement {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpansion = () =>
    setIsExpanded((prevIsExpanded) => !prevIsExpanded);

  const includeViewMore =
    props.indicators.length > 4 ||
    props.indicators.some((ind) => ind.extraInfo);

  // Asserting that props.category is a key of iconDescriptionMapping
  const categoryKey = props.category as keyof typeof iconMapper;

  const IconComponent = iconMapper[categoryKey]?.component || WarningOutlined;

  return (
    <InnerCard
      className={
        "indicator-overview-inner-card" +
        (props.className ? " " + props.className : "") +
        (isExpanded ? " expanded" : "") +
        " " +
        toKebabCase(props.verdict)
      }
    >
      {{
        header: (
          <div className="indicators-overview-card-header">
            <div className="flex-start align-items-center">
              <IconComponent className="inner-card-header-icon" />{" "}
              {/* TODO: Pass the icon as parameter? */}
              <ToolTip
                children={categoryTitles[props.category] || props.category}
                content={categoryDescriptions[props.category] || props.category}
              />
            </div>
            {/* <div className="categories-count">{props.indicators.length}</div> */}
          </div>
        ),
        content: (
          <div
            className={
              "indicators-overview-card-content" +
              (isExpanded ? " expanded" : "")
            }
          >
            <div
              className={
                (includeViewMore
                  ? "indicators-overview-card-findings-list flex-column"
                  : "indicators-overview-card-findings-list indicators-overview-card-pad no-mask") +
                (isExpanded ? " expanded" : "")
              }
            >
              {props.indicators.map((indicator, index) => (
                <IndicatorCardItem key={index} {...indicator} />
              ))}
            </div>
            <div className="flex-space-between align-items-center">
              <div
                className={
                  "indicator-verdict-label " + toKebabCase(props.verdict)
                }
              >
                {props.verdict}
              </div>
              {includeViewMore && (
                <Link className="yellow-link" onClick={toggleExpansion}>
                  {isExpanded ? "View less" : "View more"}
                </Link>
              )}
            </div>
          </div>
        ),
      }}
    </InnerCard>
  );
}
